import { createSlice } from '@reduxjs/toolkit';

const TreeSlice = createSlice({
    name: 'tree',
    initialState: {
        data: [],
    },
    reducers: {
        setTree: (state, action) => {
            state.data = action?.payload?.data;
        },
    },
});

export const { setTree } = TreeSlice.actions;
export default TreeSlice.reducer;
